import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/layout";
import { ProtectedRoute, PublicRoute } from "@/components/routing";
import { HomePage, LoginPage, AdminPage, AnnotationPage, DemographicsPage, NotFoundPage, FeedbackDemoPage, ResearchPage, RewardVerificationPage, MyRewardsPage } from "@/pages";
import "./index.css";

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          {/* Public routes */}
          <Route 
            path="login" 
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } 
          />
          
          {/* Protected routes */}
          <Route 
            index 
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } 
          />
          
          {/* Admin routes */}
          <Route 
            path="admin/*" 
            element={
              <ProtectedRoute requireAdmin>
                <AdminPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Annotation platform routes */}
          <Route 
            path="annotation" 
            element={
              <ProtectedRoute>
                <AnnotationPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="annotation/demographics" 
            element={
              <ProtectedRoute>
                <DemographicsPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Feedback demo route (admin only) */}
          <Route 
            path="feedback-demo" 
            element={
              <ProtectedRoute requireAdmin>
                <FeedbackDemoPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Research information page */}
          <Route 
            path="research" 
            element={
              <ProtectedRoute>
                <ResearchPage />
              </ProtectedRoute>
            } 
          />
          
          {/* My rewards page (user-facing) */}
          <Route 
            path="my-rewards" 
            element={
              <ProtectedRoute>
                <MyRewardsPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Reward verification page (public, token-protected for Tensorpool) */}
          <Route 
            path="verification/rewards" 
            element={<RewardVerificationPage />} 
          />
          
          {/* 404 page */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
